"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_CHANGE_CLASSES = exports.APP_WILL_UNMOUNT = exports.APP_WILL_LOAD = void 0;
exports.APP_WILL_LOAD = 'APP_WILL_LOAD';
exports.APP_WILL_UNMOUNT = 'APP_WILL_UNMOUNT';
exports.SET_CHANGE_CLASSES = 'SET_CHANGE_CLASSES';
